import { ky } from './ky';
import { PlaceDto } from '@/api/place';
import { FeedDto } from '@/api/feed';
import { AccountDto } from '@/api/account';
import { HashTagDto } from '@/api/hashtag';

export interface RecentSearchDto {
  keyword: string;
}

export interface SearchResponse {
  feeds: FeedDto[];
  places: PlaceDto[];
  accounts: AccountDto[];
  hashtags: HashTagDto[];
}

export type AutocompleteType = 'HASHTAG' | 'PLACE' | 'ACCOUNT' | 'RECENT';

export interface AutocompleteItem {
  keyword: string;
  type: AutocompleteType;
  data: HashTagDto | PlaceDto | AccountDto | RecentSearchDto;
}

export interface AutocompleteResponse {
  items: AutocompleteItem[];
}

export default class SearchService {

  async search(keyword: string) {
    return await ky.get(`v1/search`, {
      searchParams: { keyword }
    }).json() as SearchResponse;
  }

  async autocomplete(query: string = "") {
    return await ky.get(`v1/search/autocomplete`, {
      searchParams: { query }
    }).json() as AutocompleteResponse;
  }

  async getRecentSearches() {
    return await ky.get(`v1/search/recent`).json() as RecentSearchDto[];
  }

  async deleteRecentSearch(keyword: string) {
    await ky.delete(`v1/search/recent/${encodeURIComponent(keyword)}`)
  }

}
